<app-table
    [items]="store.items()"
    [columns]="columns"
    translatePrefix="person.dashboard.palliativeCare."
    [hideCheckboxes]="true"
    (detailCallback)="detail($event)"
    (deleteCallbackWithEvent)="delete($event)"
    [showDetail]="folderStore.canEdit()"
    [showDelete]="folderStore.canEdit()"
>
</app-table>
